import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    url: 'https://login.amuz.gda.pl/auth/',
    realm: 'aMuz',
    clientId: 'obieralne',
});

export default keycloak;